export default class Citation {
    selectors = {
        authorName: '.author-name',
        authorInfo: '.author-info',
        authorJsOpen: '.author-name.accordion-tabbed__control.js--open',
        editorName: '.editor__name',
    };

    elements = {
        authorsNames: null,
        authorsInfos: null,
        authorJsOpen: null,
        editorNames: null,
    };

    variables = {
        viewPortWidth: 0,
        isDesktop: true,
    };

    constructor() {
        this.init();
        this.eventListeners();
    }

    setElements() {
        this.elements.authorsInfos = document.querySelectorAll(this.selectors.authorInfo);
        this.elements.authorsNames = document.querySelectorAll(this.selectors.authorName);
        this.elements.authorJsOpen = document.querySelector(this.selectors.authorJsOpen);
        this.elements.editorNames = document.querySelectorAll(this.selectors.editorName);
    }

    eventListeners() {
        window.addEventListener('resize', this.init);
    }

    init = () => {
        this.variables.viewPortWidth = window.innerWidth;

        this.setElements();
        this.checkIfDesktop();
        this.checkAuthorInfo();
    };

    checkIfDesktop() {
        if (this.variables.viewPortWidth <= 992) {
            this.variables.isDesktop = false;
        }
    }

    checkAuthorInfo = () => {
        // check if there is a popup opened from before and close it
        this.elements.authorJsOpen && this.elements.authorJsOpen.click();

        if (!this.variables.isDesktop) {
            this.elements.authorsNames?.forEach(author => {
                author.addEventListener('click', e => {
                    let popup = author?.parentElement?.querySelector('.author-info'),
                        authorHeight = author.offsetTop + author.offsetHeight + 2;

                    popup?.setAttribute('style', `top: ${authorHeight}px`);

                    if (e.x < this.variables.viewPortWidth / 2) {
                        popup?.classList.add('left-zero');
                    }
                });
            });

            this.elements.editorNames?.forEach(editor => {
                editor.addEventListener('click', e => {
                    e.preventDefault();
                    let popup = editor?.parentElement?.querySelector('.editor__info');
                    if (e.x > this.variables.viewPortWidth / 2) {
                        popup?.classList.add('right-zero');
                    } else {
                        popup?.classList.remove('right-zero');
                    }
                });
            });
        }
    };
}
